export default __webpack_public_path__ + "static/media/Wholesale1.a4215717.jpg";